import { defineComponent as _defineComponent } from 'vue'

import TalkRoomMaster from "@/components/communityTalk/talkRoom/TalkRoomMaster.vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { TalkRoomDto } from "@/apiRequests/models/communityTalk/talkRoomGetResponse";

interface Props {
	/**
	 * トークルーム情報群。
	 */
	talkRooms: TalkRoomDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    talkRooms: { type: Array, required: true },
    wordSettings: { type: null, required: true },
    communityTalkStoreKey: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * トークルーム情報群。
	 */
	talkRooms: TalkRoomDto[];
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
}
/**
 * トークルーム一覧。
 */



const __returned__ = { props, TalkRoomMaster }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})